export const trackCallbackLead = (source) => {
  if (typeof window === "undefined") return;

  if (window.dataLayer) {
    window.dataLayer.push({
      event: "callback_request",
      lead_source: source,
    });
  }

  if (window.fbq) {
    window.fbq("track", "Lead", { content_name: source });
  }
};
